import { SidebarTrigger, useSidebar } from '@ibsys/kit';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@/shared/ui';

/** Переключатель сворачивания панели «Диалог», названный действием, доступным сейчас. */
export const DialogPanelToggle: FC = () => {
  const { t } = useTranslation(['dialogs']);
  const { open } = useSidebar();

  const label = open ? t('dialogs:collapseDialogPanel') : t('dialogs:expandDialogPanel');

  return (
    <Tooltip tooltip={label}>
      <SidebarTrigger aria-label={label} />
    </Tooltip>
  );
};
